import React, { useCallback, useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { http } from "@/lib/api";
import { toast } from "sonner";
import { UserPlus } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { Navigate } from "react-router-dom";

export default function AdminStaff() {
  const { user } = useAuth() || {};
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ email: "", name: "", password: "", role: "staff" });

  const load = useCallback(() => http.get("/auth/users").then((r) => setItems(r.data)), []);
  useEffect(() => { if (user?.role === "admin") load(); }, [user, load]);

  if (user && user.role !== "admin") return <Navigate to="/admin" replace />;

  const create = async (e) => {
    e.preventDefault();
    try {
      await http.post("/auth/staff", form);
      toast.success("Utente creato");
      setForm({ email: "", name: "", password: "", role: "staff" });
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore");
    }
  };

  return (
    <AdminLayout>
      <div className="p-10">
        <div className="eyebrow mb-2">Amministrazione</div>
        <h1 className="font-serif text-4xl mb-8">Staff & Accessi</h1>

        <div className="grid lg:grid-cols-3 gap-6">
          <form onSubmit={create} className="border border-[var(--mel-border)] rounded-md bg-white p-6" data-testid="staff-form">
            <div className="font-serif text-lg mb-4 flex items-center gap-2"><UserPlus size={18} /> Nuovo utente</div>
            <label className="text-xs eyebrow">Nome</label>
            <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full mt-1 mb-3 border rounded-md px-3 py-2 text-sm" data-testid="staff-name" />
            <label className="text-xs eyebrow">Email</label>
            <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full mt-1 mb-3 border rounded-md px-3 py-2 text-sm" data-testid="staff-email" />
            <label className="text-xs eyebrow">Password</label>
            <input required minLength="6" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full mt-1 mb-3 border rounded-md px-3 py-2 text-sm" data-testid="staff-password" />
            <label className="text-xs eyebrow">Ruolo</label>
            <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="w-full mt-1 mb-4 border rounded-md px-3 py-2 text-sm bg-white" data-testid="staff-role">
              <option value="staff">Staff</option><option value="admin">Admin</option>
            </select>
            <button className="mel-btn-primary w-full justify-center" data-testid="staff-submit">Crea</button>
          </form>

          <div className="lg:col-span-2 border border-[var(--mel-border)] rounded-md bg-white overflow-hidden">
            <table className="w-full text-sm" data-testid="staff-table">
              <thead className="bg-[var(--mel-surface)] text-left">
                <tr><th className="px-4 py-3">Nome</th><th className="px-4 py-3">Email</th><th className="px-4 py-3">Ruolo</th></tr>
              </thead>
              <tbody>
                {items.map((u) => (
                  <tr key={u.user_id} className="border-t border-[var(--mel-border)]">
                    <td className="px-4 py-3 font-medium">{u.name}</td>
                    <td className="px-4 py-3">{u.email}</td>
                    <td className="px-4 py-3"><span className="text-[10px] uppercase tracking-widest px-2 py-1 rounded-full bg-[var(--mel-surface)]">{u.role}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
